export default __webpack_public_path__ + "static/media/keto_cravings@2x.d29ba15b.jpg";